module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/invoices/invoice-view/invoice-payments-action-buttons/invoice-payment-action-buttons.scss
// module id = ./web/modern/components/invoices/invoice-view/invoice-payments-action-buttons/invoice-payment-action-buttons.scss
// module chunks = 0